<template>
  <div class="title">
    <div class="arrow05">{{title}}</div>
  </div>
</template>

<script>
export default {
  props: ['title'],
};
</script>

<style <style scoped>
div.title {
	overflow: hidden;
	margin: 0;
	padding: 0;
	list-style-type: none;
	background-color: #1b2538;
}
div.title div {
	display: block;
    padding: 0.3rem 2.5rem!important;
	margin: 0;
	text-decoration: none;
	color: white;
}
@media screen {
	div.title {
		float: none;
	}
}
.arrow05 {
	position: relative;
	padding-left: 1rem;
}
.arrow05::before {
	position: absolute;
	content: "";
	width: 0.8rem;
	height: 0.8rem;
	border-top: 0.2rem solid #697b91;
	border-right: 0.2rem solid #697b91;
	-webkit-transform: rotate(45deg);
	transform: rotate(45deg);
	top: 50%;
	left: 0;
	margin-top: -0.4rem;
	margin-left: 1rem;
}
</style>
